import { OpportunityType } from '../interface';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

export function getOpportunityTypeFromId(typeId = ''): OpportunityType {
  return OpportunityTypes.find((t) => t.id === typeId);
}

export function getDefaultOpportunityType(): OpportunityType {
  return OpportunityTypes.find((t) => t.id === '');
}

export const OpportunityTypes: OpportunityType[] = [
  {
    id: '',
    displayName: 'FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.NOT_SPECIFIED',
  },
  {
    id: 'new-business',
    displayName: 'FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.NEW_BUSINESS',
  },
  {
    id: 'existing-business',
    displayName: 'FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.EXISTING_BUSINESS',
  },
];

@Component({
  imports: [MatSelectModule, CommonModule, TranslateModule, GalaxyFormFieldModule],
  selector: 'sales-ui-type-selector',
  templateUrl: './type-selector.component.html',
})
export class TypeSelectorComponent {
  @Input() set defaultType(type: OpportunityType) {
    this.selectedType$$.next(type);
  }

  @Output() typeChanged = new EventEmitter<string>();
  opportunityTypes$$ = new BehaviorSubject<OpportunityType[]>(OpportunityTypes);
  opportunityTypes$ = this.opportunityTypes$$.asObservable();
  selectedType$$ = new BehaviorSubject<OpportunityType>(OpportunityTypes[0]);
  selectedType$ = this.selectedType$$.asObservable();

  emitTypeChange(type: string): void {
    this.typeChanged.emit(type);
  }
}
